// src/i18n/monitoringGreek.js
//
// Greek for the strings the Monitoring screens receive from the backend as
// data and render verbatim: vendor labels, the "how the client grants
// access" guidance, credential field labels and their help, cost notes.
// The screens' own copy lives in src/monitoring/i18n.js; these are the
// vendor specs from api/services/monitoring/connectors, translated whole so
// the DOM bridge can match them exactly. Keep in step with that file.

const monitoringGreek = {
  "Simulated (demonstration)": "Προσομοίωση (επίδειξη)",
  // Device names the simulated source reports.
  "Plant meter": "Μετρητής πάρκου",
  "Grid meter": "Μετρητής δικτύου",
  "Irradiance sensor": "Αισθητήρας ακτινοβολίας",
  "Pyranometer": "Πυρανόμετρο",
  "No access needed. Telemetry is generated from the park's plant parameters and clear-sky physics with a synthetic cloud cover.":
    "Δεν χρειάζεται πρόσβαση. Οι μετρήσεις παράγονται από τα χαρακτηριστικά του πάρκου και τη φυσική καθαρού ουρανού με συνθετική νέφωση.",

  // Huawei FusionSolar
  "In FusionSolar the plant owner opens System > Company management > Northbound management, adds a Northbound user, ticks the plants to share and the data types (real-time KPIs, 5-minute history, alarms), and sends us the username and system code.":
    "Στο FusionSolar ο ιδιοκτήτης του πάρκου ανοίγει System > Company management > Northbound management, προσθέτει έναν χρήστη Northbound, επιλέγει τα πάρκα που θα μοιραστεί και τους τύπους δεδομένων (KPIs πραγματικού χρόνου, ιστορικό 5 λεπτών, συναγερμοί) και μας στέλνει το όνομα χρήστη και τον κωδικό συστήματος (systemCode).",
  "API host": "Διεύθυνση API",
  "e.g. https://eu5.fusionsolar.huawei.com": "π.χ. https://eu5.fusionsolar.huawei.com",
  "Northbound username": "Όνομα χρήστη Northbound",
  "Created by the plant owner under System > Company management > Northbound management.":
    "Δημιουργείται από τον ιδιοκτήτη του πάρκου στο System > Company management > Northbound management.",
  "Northbound password (systemCode)": "Κωδικός Northbound (systemCode)",

  // SolarEdge
  "SolarEdge Monitoring": "SolarEdge Monitoring",
  "The site admin opens the site in monitoring.solaredge.com, Admin > Site Access > API Access, accepts the terms and generates a key. One key per site, or an account key for all sites.":
    "Ο διαχειριστής του πάρκου ανοίγει το πάρκο στο monitoring.solaredge.com, Admin > Site Access > API Access, αποδέχεται τους όρους και δημιουργεί κλειδί. Ένα κλειδί ανά πάρκο, ή ένα κλειδί λογαριασμού για όλα.",
  "Free; 300 requests per site per day.": "Δωρεάν· 300 αιτήματα ανά πάρκο ανά ημέρα.",
  "API key": "Κλειδί API",
  "Admin > Site Access > API Access in the SolarEdge monitoring portal.": "Admin > Site Access > API Access στο portal παρακολούθησης SolarEdge.",

  // Sungrow
  "Apply for OpenAPI access at developer-api.isolarcloud.com with the client's portal account; approval takes a few working days and returns an appkey. Start this in week one.":
    "Αίτηση πρόσβασης OpenAPI στο developer-api.isolarcloud.com με τον λογαριασμό portal του πελάτη· η έγκριση παίρνει λίγες εργάσιμες ημέρες και επιστρέφει appkey. Ξεκινήστε το την πρώτη εβδομάδα.",
  "e.g. https://gateway.isolarcloud.eu": "π.χ. https://gateway.isolarcloud.eu",
  "Application key (appkey)": "Κλειδί εφαρμογής (appkey)",
  "Secret key": "Μυστικό κλειδί",
  "Only when RSA signing is enabled for the application.": "Μόνο όταν είναι ενεργή η υπογραφή RSA για την εφαρμογή.",
  "Portal username": "Όνομα χρήστη portal",
  "Portal password": "Κωδικός portal",

  // Fronius
  "The plant owner needs Solar.web Premium (or Business) on the system, then generates an API key under Settings > API keys and shares ID and value.":
    "Ο ιδιοκτήτης του πάρκου χρειάζεται Solar.web Premium (ή Business) στο σύστημα, έπειτα δημιουργεί κλειδί API στο Settings > API keys και μοιράζεται ID και τιμή.",
  "Requires the paid Solar.web Premium / Business tier on each system.": "Απαιτεί τη συνδρομή Solar.web Premium / Business σε κάθε σύστημα.",
  "Access key ID": "ID κλειδιού πρόσβασης",
  "Access key value": "Τιμή κλειδιού πρόσβασης",

  // SMA
  "Register an application on developer.sma.de, then the plant owner approves the application's access to each plant in Sunny Portal powered by ennexOS. Plants still on the classic Sunny Portal cannot be read this way.":
    "Καταχώριση εφαρμογής στο developer.sma.de· έπειτα ο ιδιοκτήτης εγκρίνει την πρόσβαση της εφαρμογής σε κάθε πάρκο στο Sunny Portal powered by ennexOS. Πάρκα που παραμένουν στο κλασικό Sunny Portal δεν διαβάζονται με αυτόν τον τρόπο.",
  "Client ID": "Client ID",
  "Client secret": "Client secret",

  // meteocontrol
  "The client orders the VCOM API licence from meteocontrol for the systems to be read and shares the key with a VCOM user that can see those systems.":
    "Ο πελάτης παραγγέλνει την άδεια VCOM API από τη meteocontrol για τα συστήματα που θα διαβάζονται και μοιράζεται το κλειδί μαζί με έναν χρήστη VCOM που βλέπει αυτά τα συστήματα.",
  "VCOM API licence is a paid add-on per system.": "Η άδεια VCOM API είναι πρόσθετη χρέωση ανά σύστημα.",
  "VCOM username": "Όνομα χρήστη VCOM",
  "VCOM password": "Κωδικός VCOM",

  // Solar-Log
  "The plant owner needs an Enerest tier with API access (Enerest M or higher) and creates a token under Account > API.":
    "Ο ιδιοκτήτης χρειάζεται βαθμίδα Enerest με πρόσβαση API (Enerest M ή ανώτερη) και δημιουργεί token στο Account > API.",
  "API access depends on the Enerest tier.": "Η πρόσβαση API εξαρτάται από τη βαθμίδα Enerest.",
  "API token": "Token API",
};

export default monitoringGreek;
